import PropTypes from 'prop-types';
import React, { Component } from 'react';

class CounterInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            max: this.props.max,
            min: this.props.min
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const { max } = this.props;
        if (prevProps.max !== max) {
            this.setState({ max: this.props.max });
        }
    }

    incrementCounter = () => {
        const { value } = this.props;
        const { max } = this.state;
        let quantity = value < max ? value + 1 : value;

        if (typeof this.props.handleChange === 'function') {
            this.props.handleChange(quantity);
        }
    };

    decreaseCounter = () => {
        const { value } = this.props;
        const { min } = this.state;
        let quantity = value > min ? value - 1 : value;

        if (typeof this.props.handleChange === 'function') {
            this.props.handleChange(quantity);
        }
    };

    changeNumeric = event => {
        const { min, max } = this.state;
        let quantity = parseInt(event.target.value, 10);

        if (quantity <= min) quantity = min;
        if (quantity >= max) quantity = max;
        if (isNaN(quantity)) quantity = min;

        if (typeof this.props.handleChange === 'function') {
            this.props.handleChange(quantity);
        }
    };

    handleBlur = () => {
        const { value } = this.props;
        if (isNaN(value) && typeof this.props.handleChange === 'function') {
            this.props.handleChange(1);
        }
    };

    render() {
        return (
            <div className='counter-box'>
                <button
                    className='btn btn-primary'
                    onClick={this.decreaseCounter}
                >
                    <i className='ms-Icon ms-Icon--Remove' aria-hidden='true' />
                </button>
                <input
                    type='text'
                    className='count-input'
                    value={this.props.value || ''}
                    onChange={this.changeNumeric}
                    onBlur={this.handleBlur}
                    autoFocus={this.props.focus}
                />
                <button
                    className='btn btn-primary'
                    onClick={this.incrementCounter}
                >
                    <i className='ms-Icon ms-Icon--Add' aria-hidden='true' />
                </button>
            </div>
        );
    }
}

CounterInput.propTypes = {
    value: PropTypes.number.isRequired,
    disabled: PropTypes.bool,
    handleChange: PropTypes.func.isRequired,
    handleBlur: PropTypes.func,
    min: PropTypes.number,
    max: PropTypes.number
};

CounterInput.defaultProps = {
    min: 1,
    max: 100
};

export default CounterInput;
